import script from "/home/l/dev/unolet/unolet/frontend/src/ts/vue/components/TableHeaderSort.vue?type=script"
export * from "/home/l/dev/unolet/unolet/frontend/src/ts/vue/components/TableHeaderSort.vue?type=script"
export default script